import { useEffect, useState } from "react";
import { ATLAS_WARNING } from "@shared/copy";
import { api } from "../lib/api";
import type { AssumptionView } from "@shared/types";
import { AssumptionCard } from "../components/AssumptionCard";

export function Assumptions() {
  const [assumptions, setAssumptions] = useState<AssumptionView[]>([]);
  const [paramType, setParamType] = useState("");
  useEffect(() => {
    const q = paramType ? `?paramType=${encodeURIComponent(paramType)}` : "";
    api<{ assumptions: AssumptionView[] }>(`/api/model-assumptions${q}`).then((r) => setAssumptions(r.assumptions)).catch(() => setAssumptions([]));
  }, [paramType]);
  return (
    <section className="page-hero">
      <div className="wrap">
        <p className="kicker">Assumption Atlas</p>
        <h1>Practice, made legible.</h1>
        <p className="lede">{ATLAS_WARNING} This atlas does not rank practitioners.</p>
        <p>
          <button className="btn btn-ghost" type="button" onClick={() => setParamType("")}>All</button>{" "}
          <button className="btn btn-ghost" type="button" onClick={() => setParamType("Manning n")}>Manning n</button>{" "}
          <button className="btn btn-ghost" type="button" onClick={() => setParamType("blockage")}>Blockage</button>{" "}
          <button className="btn btn-ghost" type="button" onClick={() => setParamType("downstream boundary")}>Boundaries</button>
        </p>
        <div className="grid-2" style={{ marginTop: 24 }}>
          {assumptions.map((a) => (
            <AssumptionCard key={a.id} a={a} />
          ))}
        </div>
      </div>
    </section>
  );
}
